<div class="modal-header justify-content-end pb-0 border-0">
  <button
    name="modalRef"
    type="button"
    class="btn-close pull-right"
    aria-label="Close"
    (click)="ModalRef.hide()"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div
  class="modal-body px-5 pt-4 pb-5"
  style="max-height: 500px; overflow-y: auto"
>
  <p style="font-size: 1.7rem; color: #000" class="text-center">
    Tus datos fueron enviados exitosamente, ya estamos procesando el reembolso,
    te enviaremos un email cuando este lista la devolución.
  </p>
  <p class="text-center">No olvides seguirnos en redes sociales</p>
  <div class="flex justify-content-around w-75 m-auto">
    <a [href]="config.company.facebook" rel="noopener" target="_blank">
      <img
        src="../../../../../assets/images/logos/facebook.png"
        style="width: 48px"
      />
    </a>
    <a [href]="config.company.instagram" rel="noopener" target="_blank">
      <img
        src="../../../../../assets/images/logos/instagram.png"
        style="width: 48px"
      />
    </a>
    <a [href]="config.company.linkedin" rel="noopener" target="_blank">
      <img
        src="../../../../../assets/images/logos/linkedin.png"
        style="width: 48px"
      />
    </a>
    <a [href]="config.company.youtube" rel="noopener" target="_blank">
      <img
        src="../../../../../assets/images/logos/youtube.png"
        style="width: 48px"
      />
    </a>
  </div>
</div>

<div class="modal-footer justify-content-center">
  <a [routerLink]="['/inicio']" class="btn-link" (click)="ModalRef.hide()"
    >Visita nuestra página web</a
  >
</div>
